module.exports = __webpack_public_path__ + "img/7.45c9d94e.jpg";